import 'react-table/react-table.css'

import { useRouterContext } from '@speedlo/hooks'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { useAccountMap } from '../hooks/useAccountMap'
import { AccountsTable } from '../molecules/AccountsTable'

export const DashboardTable = observer(() => {
  const { history } = useRouterContext()
  const [accounts, isLoading] = useAccountMap()

  const onAccountClick = React.useCallback((accountId: string) => {
    const account = accounts.get(accountId)
    if (account) {
      history.push(`/admin/${account.id}`)
    }
  }, [])

  return (
    <AccountsTable
      accounts={Array.from(accounts.values())}
      isLoading={isLoading}
      onAccountClick={onAccountClick}
    />
  )
})
